import { PosIconProps, SvgWrapper } from './SvgWrapper';

export function SignalStep0Icon(props: Omit<PosIconProps, 'viewBox'>) {
  return (
    <SvgWrapper {...props} viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="10" fill="#F2B824" />
    </SvgWrapper>
  );
}
